import React from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
  return (
    <div className="container text-center px-4 pt-24 mx-auto md:pt-32 lg:px-0 dark:bg-gray-900">
      <h2 class="text-2xl font-bold dark:text-white">Contact</h2>
      <p class="mt-10 text-lg md:text-md text-gray-700 dark:text-gray-400">
        Hello! TOOlover is built and maintained by me, <Link target='_blank' to='https://github.com/dereknguyen269' className="font-medium text-blue-600 dark:text-blue-500 hover:underline">Derek Nguyen</Link> 👋
      </p>
    </div>
  )
}

export default Contact;